import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, finalize, Observable } from 'rxjs';
import { generateQueryString } from '../functions';
import { ConfigService } from '../../core/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);
  public readonly loading$ = this.loadingSubject.asObservable();

  getInputDocumentsByUserId(params: { [key: string]: any }): Observable<any> {
    this.loadingSubject.next(true);

    return this.http
      .get(
        this.config.apiUrl +
          '/ServiceDesk/api/Documents/GetAllInputDocumentsByUserId' +
          generateQueryString(params)
      )
      .pipe(finalize(() => this.loadingSubject.next(false)));
  }

  GetAllOutputDocumentsByUserId(params: {
    [key: string]: any;
  }): Observable<any> {
    this.loadingSubject.next(true);

    return this.http
      .get(
        this.config.apiUrl +
          '/ServiceDesk/api/Documents/GetAllOutputDocumentsByUserId' +
          generateQueryString(params)
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false)),
        catchError((error) => {
          console.error('Error fetching another data:', error);
          throw error; // Rethrow or handle as needed
        })
      );
  }

  getDocumentsByRequestId(params: { [key: string]: any }): Observable<any> {
    this.loadingSubject.next(true);
    return this.http
      .get(
        this.config.apiUrl +
          '/ServiceDesk/api/Documents/GetAllDocumentsByRequestId' +
          generateQueryString(params)
      )
      .pipe(finalize(() => this.loadingSubject.next(false)));
  }

  getDocumentsCount() {
    this.loadingSubject.next(true);
    return this.http
      .get(this.config.apiUrl + '/ServiceDesk/api/Documents/GetDocumentsCount')
      .pipe(finalize(() => this.loadingSubject.next(false)));
  }

  getLatestNotifications(params: { [key: string]: any }): Observable<any> {
    this.loadingSubject.next(true);

    return this.http
      .get(
        this.config.apiUrl +
          '/ServiceDesk/api/Notification/GetLatestNotifications' +
          generateQueryString(params)
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false)),
        catchError((error) => {
          console.error('Error fetching another data:', error);
          throw error; // Rethrow or handle as needed
        })
      );
  }

  getNotificationsLastSeenDate() {
    this.loadingSubject.next(true);
    return this.http
      .get(
        this.config.apiUrl +
          '/Backend/api/Preferences/GetUserNotificationLastSeenDate',
        { responseType: 'text' }
      )
      .pipe(finalize(() => this.loadingSubject.next(false)));
  }

  setNotificationsLastSeenDate() {
    this.loadingSubject.next(true);
    return this.http
      .put(
        this.config.apiUrl +
          '/Backend/api/Preferences/SetUserNotificationLastSeenDate',
        null
      )
      .pipe(finalize(() => this.loadingSubject.next(false)));
  }
}
